import { Card, Group, Stack, Text } from '@mantine/core'
import { AutoRenewingAdResponse } from '../../../data/hostDashboard.service'
import { COLORS } from '../../../utils/constants'
import { formatNumber } from '../../../utils/displayUtils'

type AutoRenewingAdCardProps = {
  ad: AutoRenewingAdResponse
}

const AutoRenewingAdCard = ({ ad }: AutoRenewingAdCardProps) => {
  return (
    <Card key={ad.id} withBorder shadow='sm' radius='md'>
      <Stack gap='xs'>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Advertiser
          </Text>
          <Text size='sm' ta={'right'}>
            {ad.advertiserOrganizationName}
          </Text>
        </Group>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Location / Device
          </Text>
          <Text size='sm' ta={'right'}>
            {`${ad.locationName} - ${ad.deviceName}`}
          </Text>
        </Group>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Ad Name
          </Text>
          <Text size='sm' ta={'right'}>
            {ad.adName}
          </Text>
        </Group>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Refresh Interval
          </Text>
          <Text size='sm' ta={'right'}>
            {ad.numberOfDaysToRunAd
              ? `${ad.numberOfDaysToRunAd} days`
              : 'Custom'}
          </Text>
        </Group>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Next Renewal
          </Text>
          <Text size='sm' ta={'right'}>
            {new Date(ad.nextRenewalDate)?.toLocaleDateString()}
          </Text>
        </Group>
        <Group justify='space-between' wrap='nowrap'>
          <Text fw={500} size='sm' c='dimmed'>
            Amount
          </Text>
          <Text fw={600} size='sm' c={COLORS.LightGreen} ta={'right'}>
            ${formatNumber(ad.lastTransferAmount)}
          </Text>
        </Group>
      </Stack>
    </Card>
  )
}

export default AutoRenewingAdCard
